<template>
  <div>
    <div id="step0" class="px-3 pt-12 mt-6" v-if="countPersonalData === 0">
      <p key="InfoAditional" ref="InfoAditional" class="text-center black--text font-weight-bold subtitle-1">
        1. Datos esenciales de contacto
      </p>
      <v-img src="../../../assets/profesionales.png" aspect-ratio="1.7" contain style="border-radius: 50%"></v-img>
      <p class="grey--text text--darken-1 subtitle-1 text-center pt-4">
        Debes asegurarte que tus datos estén escritos correctamente. A tu
        <span class="subtitle-1 grey--text text--darken-1 font-weight-bold text-center pt-4">
          correo y número de celular</span
        >
        se enviará información importante para que continues con tu proceso de selección.
      </p>
    </div>
    <div id="step1" class="px-3 pt-12 mt-6 d-flex justify-center" v-if="countPersonalData === 1">
      <v-form ref="form" v-model="addPersonalData.datosValidPer">
        <p key="DPname" ref="DPname" class="text-center black--text font-weight-bold subtitle mb-4">
          ¿Cuál es tu nombre?
        </p>
        <v-text-field
          :rules="nameRules"
          outlined
          pattern="[a-zA-Z]*"
          type="text"
          v-model.trim="addPersonalData.nombres"
          class="pt-0 grey-label"
          color="#2800C8"
          maxlength="40"
          label="Nombres"
        ></v-text-field>
        <p key="DPsurname" ref="DPsurname" class="text-center font-weight-bold black--text subtitle mb-4 mt-4">
          ¿Cuáles son tus apellidos?
        </p>
        <v-text-field
          :rules="lastName1Rules"
          class="grey-label"
          pattern="[a-zA-Z]*"
          outlined
          type="text"
          v-model.trim="addPersonalData.apellido_p"
          color="#2800C8"
          label="Apellido Paterno"
          maxlength="30"
        ></v-text-field>
        <v-text-field
          :rules="lastName2Rules"
          class="grey-label"
          outlined
          pattern="[a-zA-Z]*"
          type="text"
          v-model.trim="addPersonalData.apellido_m"
          color="#2800C8"
          label="Apellido Materno"
          maxlength="30"
        ></v-text-field>
        <v-row class="mt-3">
          <v-alert dense outlined type="error">
            Verifica que tus nombres y apellidos estén escritos como en tu <strong>documento.</strong>
          </v-alert>
        </v-row>
        <p key="DPborn" ref="DPborn" class="text-center black--text font-weight-bold subtitle my-4">
          ¿Cuál es tu fecha de nacimiento?
        </p>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              class="grey-label"
              v-model="addPersonalData.fecha_nac"
              label="Fecha de nacimiento"
              color="#2800C8"
              required
              outlined
              append-icon="mdi-calendar"
              readonly
              v-on="on"
              :rules="[(v) => !!v || 'Fecha de nacimiento es requerido']"
            ></v-text-field>
          </template>
          <v-date-picker
            color="#2800C8"
            locale="es"
            ref="picker"
            v-model="addPersonalData.fecha_nac"
            :max="isSixteenYearsOld()"
            min="1950-01-01"
            @change="saveBirthDay"
          ></v-date-picker>
        </v-menu>
      </v-form>
    </div>
    <div id="step2" class="px-3 pt-12 mt-6" v-if="countPersonalData === 2">
      <v-form ref="form" v-model="addPersonalData.datosValidPer">
        <p key="DPgener" ref="DPgener" class="text-center black--text font-weight-bold subtitle mb-0">
          ¿Cuál es tu sexo?
        </p>
        <v-radio-group
          @change="changeGender"
          v-model="addPersonalData.genero"
          class="body-1"
          :mandatory="false"
          :rules="[(v) => !!v || 'Género es requerido']"
        >
          <v-radio label="Femenino" value="Femenino" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
          <v-radio label="Masculino" value="Masculino" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
          <v-radio label="Intersexual" value="Intersexual" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
        </v-radio-group>
        <v-expand-transition>
          <div id="step5.1" v-if="addPersonalData.genero === 'Intersexual'" class="px-3 pt-2">
            <p class="text-center black--text font-weight-bold subtitle mb-4">¿Cuál es tu nombre social?</p>
            <v-text-field
              outlined
              label="Nombre social"
              v-model.trim="addPersonalData.nombre_social_intersexual"
              class="pt-2 grey-label"
              color="#2800C8"
              maxlength="20"
            ></v-text-field>
            <p class="grey--text body-2 text-justify pt-6">
              *Nombre Social: Nombre adoptado por una persona trans, con la finalidad de coincidir con su identidad de
              género, con la que se siente identificada y reconocida. En Konecta estamos comprometidos/as con la
              diversidad. Valoramos a cada persona por quién es, y le brindamos oportunidades de crecimiento en un
              entorno seguro y libre de discriminación.
            </p>
          </div>
        </v-expand-transition>
        <p key="DPgener" ref="DPgener" class="text-center black--text font-weight-bold subtitle mb-0">
          ¿Cuentas con algun tipo de discapacidad?
        </p>
        <v-radio-group
          v-model="addPersonalData.tieneDiscapacidad"
          @change="changeDiscapacidad"
          class="body-1"
          :rules="[v => v !== null && v !== undefined || 'Este campo es obligatorio']"
        >
          <v-radio label="Sí" :value="true"  color="#2800C8" class="pa-2 radioStateCivil"/>
          <v-radio label="No" :value="false" color="#2800C8" class="pa-2 radioStateCivil"/>
        </v-radio-group>
        <v-expand-transition>
          <div id="step5.1" v-if="addPersonalData.tieneDiscapacidad === true" class="px-3 pt-2">
            <p key="DPgener" ref="DPgener" class="text-center black--text font-weight-bold subtitle mb-0">
              ¿Cual es tu tipo de discapacidad?
            </p>
            <v-radio-group
              v-model="addPersonalData.tipoDiscapacidad"
              class="body-1"
              :mandatory="false"
            >
              <v-radio
                label="Discapacidad física (Tienes alguna/as limitación/es de forma permanente para moverte o caminar y/o para usar tus capacidades motoras o físicas)"
                value="Discapacidad física (Tienes alguna/as limitación/es de forma permanente para moverte o caminar y/o para usar tus capacidades motoras o físicas)"
                color="#2800C8"
                class="pa-2 radioStateCivil"
              ></v-radio>
              <v-radio
                label="Discapacidad sensorial (Tienes alguna/as limitaciones de forma permanente para ver y/o incluso usando anteojos, hablar o comunicarte y/o inclusive usando lenguaje de señas, oír y/o incluso utilizando audiófonos medicados)"
                value="Discapacidad sensorial (Tienes alguna/as limitaciones de forma permanente para ver y/o incluso usando anteojos, hablar o comunicarte y/o inclusive usando lenguaje de señas, oír y/o incluso utilizando audiófonos medicados)"
                color="#2800C8"
                class="pa-2 radioStateCivil"
              ></v-radio>
              <v-radio
                label="Discapacidad intelectual (Tienes alguna/as limitaciones del funcionamiento intelectual que dificulta el desarrollo de habilidades sociales, intelectuales y de aprendizaje)"
                value="Discapacidad intelectual (Tienes alguna/as limitaciones del funcionamiento intelectual que dificulta el desarrollo de habilidades sociales, intelectuales y de aprendizaje)"
                color="#2800C8"
                class="pa-2 radioStateCivil"
              ></v-radio>
              <v-radio
                label="Discapacidad psíquica (Tienes alguna/ limitaciones de tipo conductual y del comportamiento adaptativo)"
                value="Discapacidad psíquica (Tienes alguna/ limitaciones de tipo conductual y del comportamiento adaptativo)"
                color="#2800C8"
                class="pa-2 radioStateCivil"
              ></v-radio>
              <v-radio
                label="Discapacidad visceral (Tienes padecimiento de algún tipo de deficiencia en alguno de tus órganos y/o enfermedades como Diabetes o problemas cardíacos)"
                value="Discapacidad visceral (Tienes padecimiento de algún tipo de deficiencia en alguno de tus órganos y/o enfermedades como Diabetes o problemas cardíacos)"
                color="#2800C8"
                class="pa-2 radioStateCivil"
              ></v-radio>
              <v-radio
                label="Discapacidad múltiple (Presencia de dos o más limitaciones derivadas de algunas de las anteriores deficiencias)"
                value="Discapacidad múltiple (Presencia de dos o más limitaciones derivadas de algunas de las anteriores deficiencias)"
                color="#2800C8"
                class="pa-2 radioStateCivil"
              ></v-radio>
            </v-radio-group>
            <p key="DPgener" ref="DPgener" class="text-center black--text font-weight-bold subtitle mb-0">
              ¿Cuentas con carnet conadis?
            </p>
            <v-radio-group
              v-model="addPersonalData.tieneCarnetConadis"
              class="body-1"
              :mandatory="false"
            >
              <v-radio label="Sí" :value="true" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
              <v-radio label="No" :value="false" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
            </v-radio-group>
          </div>
        </v-expand-transition>
      </v-form>
    </div>
    <div id="step3" class="px-3 pt-12 mt-6" v-if="countPersonalData === 3">
      <v-form ref="form" v-model="addPersonalData.datosValidPer">
        <p key="city" ref="city" class="text-center black--text font-weight-bold subtitle mb-0">
          ¿En cuál provincia vives?
        </p>
        <v-radio-group
          v-model="addPersonalData.provincia"
          @change="changeDistrict"
          class="body-1 mt-4"
          :mandatory="false"
          :rules="[(v) => !!v || 'Tu provincia de residencia es requerida']"
        >
          <v-radio label="Chiclayo" value="E" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
          <v-radio label="Lima" value="A" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
          <v-radio label="Piura" value="P" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
          <v-radio label="Trujillo" value="T" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
          <v-radio label="Arequipa" value="AREQUIPA" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
          <v-radio label="Otra" value="OTHER" color="#2800C8" class="pa-2 radioStateCivil"></v-radio>
        </v-radio-group>
        <v-expand-transition>
          <div id="step5.1" v-if="addPersonalData.provincia !== ''" class="px-3 pt-2">
            <p key="district" ref="district" class="text-center black--text font-weight-bold subtitle mb-4">
              ¿Cuál es tu distrito de residencia?
            </p>
            <v-select
              v-if="addPersonalData.provincia !== 'OTHER'"
              v-model="addPersonalData.distrito"
              class="grey-label"
              color="#2800C8"
              :items="availableDistricts"
              :rules="[(v) => !!v || 'El distrito es requerido']"
              label="Distrito"
              outlined
              required
            >
            </v-select>
            <v-text-field
              v-else
              v-model="addPersonalData.distrito"
              class="grey-label"
              color="#2800C8"
              :rules="[(v) => !!v || 'El distrito es requerido']"
              label="Distrito"
              outlined
              required
            >
            </v-text-field>
          </div>
        </v-expand-transition>
      </v-form>
    </div>
    <div id="step4" class="px-3 pt-12 mt-6" v-if="countPersonalData === 4">
      <v-form ref="form" v-model="addPersonalData.datosValidPer">
        <p key="DPphone" ref="DPphone" class="text-center black--text font-weight-bold subtitle mb-2 pt-4">
          ¿Cuál es tu número de celular?
        </p>
        <p class="caption grey--text text--darken-2">
          Asegúrate de registrar un número celular donde contactemos fácilmente contigo.
        </p>
        <v-text-field
          class="grey-label"
          min="0"
          outlined
          label="Número de celular"
          v-model.trim="addPersonalData.telefono"
          placeholder="555555555"
          color="#2800C8"
          required
          maxlength="9"
          type="number"
          pattern="[0-9]*"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          @keypress="isNumber($event)"
          :rules="phoneRules"
        />
        <v-text-field
          v-show="false"
          class="grey-label"
          min="0"
          outlined
          label="Celular Adicional"
          v-model.trim="addPersonalData.telefonoReferencial"
          placeholder="999999999"
          color="#2800C8"
          required
          maxlength="9"
          type="number"
          pattern="[0-9]*"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          @keypress="isNumber($event)"
          :rules="additionalPhoneRules"
        ></v-text-field>
        <p key="DPemail" ref="DPemail" class="text-center black--text font-weight-bold subtitle mb-2">
          ¿Cuál es tu correo electrónico?
        </p>
        <p class="caption grey--text text--darken-2" style="margin-bottom: 2px">
          Asegúrate de registrar el correo que usas habitualmente.
        </p>
        <p class="caption grey--text text--darken-2">Se enviará un código de verificación por correo electrónico.</p>
        <div v-if="!isLoading">
          <v-text-field
            ref="emailField"
            v-model.trim="addPersonalData.correo"
            :rules="emailRules"
            label="Correo electrónico"
            placeholder="example@gmail.com"
            outlined
            color="#2800C8"
            prepend-inner-icon="mdi-email"
            hide-details="auto"
            required
            :disabled="otpSent"
            @copy.prevent
            @paste.prevent
          />

          <v-btn
            block
            color="#2800C8"
            :style="otpSent || !addPersonalData.correo || !isEmailValid ? 'color: #999' : 'color: #fff'"
            class="mb-6 mt-1"
            @click="validateEmail"
            :disabled="otpSent || !addPersonalData.correo || !isEmailValid"
            v-if="!otpSuccess"
          >
            Enviar token
            <span v-if="otpSent"> ({{ countdownDisplay }})</span>
          </v-btn>

          <p class="caption grey--text text--darken-2" v-if="otpSent" style="margin-bottom: 8px">
            Se le envió un código de verificación por correo electrónico.
          </p>

          <v-text-field
            v-model.trim="addPersonalData.otp"
            outlined
            class="grey-label"
            label="Escribe el código que te hemos enviado"
            color="#2800C8"
            :rules="otpRules"
            maxlength="6"
            @input="onOtpInput"
            :disabled="!otpSent"
            required
            v-if="!otpSuccess"
          ></v-text-field>
        </div>

        <!-- Muestra loader mientras isLoading es true -->
        <v-progress-circular
          v-else
          indeterminate
          color="#2800C8"
          size="70"
          class="my-5 d-flex justify-center"
          style="width: 100%"
        />
        <v-alert v-if="otpSuccess" class="my-5 px-5 mx-4" text dense color="green">
          ¡Código correcto! Ya puedes continuar con tu proceso de selección.
        </v-alert>
      </v-form>
    </div>
    <div id="step5" class="px-3 pt-12 mt-6" v-if="countPersonalData === 5">
      <v-form ref="form" v-model="addPersonalData.datosValidPer">
        <p key="DPcomoKonecta" ref="DPcomoKonecta" class="text-center black--text font-weight-bold subtitle mb-4">
          ¿Cómo conociste a Konecta?
        </p>
        <v-select
          @change="changeReference"
          outlined
          v-model="addPersonalData.como_konecta"
          :items="itemsComoKonecta"
          :rules="[(v) => !!v || 'Selecciona una opción']"
          label="Nos conociste"
          color="#2800C8"
          class="grey-label"
        ></v-select>
        <v-expand-transition>
          <div id="step8.1" v-if="addPersonalData.como_konecta === 'Referido/a'" class="pt-4">
            <p key="DPtypedoc" ref="DPtypedoc" class="text-center black--text font-weight-bold subtitle mb-2 mt-1">
              Tipo de documento
            </p>
            <p key="DPcolaborator" ref="DPcolaborator" class="text-center grey--text text--darken-3 body-1 mb-4">
              Ingresa los datos del colaborador que trabaja en Konecta
            </p>
            <v-select
              v-model="addPersonalData.documentTypeColaborador"
              :items="DocumentType"
              :rules="[(v) => !!v || 'El tipo de documento es requerido']"
              label="Seleccionar"
              class="grey-label"
              outlined
              required
            ></v-select>
            <v-text-field
              v-if="
                addPersonalData.documentTypeColaborador !== 'Pasaporte' &&
                addPersonalData.documentTypeColaborador !== 'Permiso Temporal de Permanencia' &&
                addPersonalData.documentTypeColaborador !== 'Carnet de Extranjeria'
              "
              v-model.trim="addPersonalData.nroDoc_colaborador"
              type="number"
              class="grey-label"
              maxlength="8"
              outlined
              pattern="[0-9]*"
              oninput="javascript:
                    if (this.value.length > this.maxLength)
                    this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="dniRules"
              placeholder="Número de DNI"
              label="Número"
              required
            ></v-text-field>
            <v-text-field
              v-if="addPersonalData.documentTypeColaborador === 'Pasaporte'"
              v-model.trim="addPersonalData.nroDoc_colaborador"
              class="grey-label"
              maxlength="11"
              outlined
              label="Número de Pasaporte"
              type="number"
              pattern="[0-9]*"
              oninput="javascript:
                    if (this.value.length > this.maxLength)
                    this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="pasaporteRules"
              placeholder="Ingrese el número de pasaporte"
              required
            ></v-text-field>

            <v-text-field
              v-if="
                addPersonalData.documentTypeColaborador === 'Permiso Temporal de Permanencia' ||
                addPersonalData.documentTypeColaborador === 'Carnet de Extranjeria'
              "
              v-model.trim="addPersonalData.nroDoc_colaborador"
              maxlength="9"
              outlined
              label="Número de documento"
              class="grey-label"
              type="number"
              pattern="[0-9]*"
              oninput="javascript:
                    if (this.value.length > this.maxLength)
                    this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="ptpteRules"
              placeholder="Ingrese el número de documento"
              required
            ></v-text-field>
            <v-checkbox
              v-model="addPersonalData.misma_cuenta"
              label="Quiero trabajar en la misma cuenta"
              value="Si"
              color="#2800C8"
              hide-details
              required
              class="pt-6 body-2 black--text"
            ></v-checkbox>
          </div>
        </v-expand-transition>
      </v-form>
    </div>
    <ModalValidate v-model="showModalValidate" :type="modalType" :postulantData="postulantData" />
    <div id="step5" class="px-3 pt-12 mt-6" v-if="countPersonalData === 6">
      <p key="InfoAditional" ref="InfoAditional" class="text-center black--text font-weight-bold subtitle-1">
        2. Cuéntanos sobre tu formación académica
      </p>
      <v-img src="../../../assets/profesionales.png" aspect-ratio="1.7" contain style="border-radius: 50%"></v-img>
      <p class="grey--text text--darken-1 subtitle-1 text-center pt-4">
        Tu información académica nos ayudará a poder conocerte mejor y ofrecerte propuestas especiales para ti.
      </p>
    </div>
  </div>
</template>
<script>
// import { getPostulantByDoc, validateDocumentWithIGC } from '../../services/dynamo/postulants';
import { sendToken, validToken } from "../../../services/dynamo/postulants";
export default {
  name: "personal_ata_step",
  components: {
    ModalValidate: () => import("../modals/ModalValidate.vue"),
  },
  props: {
    countPersonalData: {
      default: 0,
    },
    addPersonalData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nameRules: [
        (v) => (!!v && v.trim().length > 0) || "El nombre es requerido",
        (v) =>
          /^[áéíóúÁÉÍÓÚñÑäöüÄÖÜ a-zA-Z]+$/.test(v) || "El nombre no es válido, sólo se aceptan letras, tilde y espacio",
      ],
      otpRules: [(v) => (v && v.length === 6) || "El número debe ser de 6 carácteres"],
      formValid: false,
      otpSent: false,
      otpSuccess: false,
      showModalValidate: false,
      isLoading: false,
      modalType: "tokenNotFound",
      postulantData: {},
      countdown: 0,
      availableDistricts: [],
      dniRules: [
        (v) => !!v || "Ingresa el DNI del colaborador que trabaja en Konecta",
        (v) => (v && v.length === 8) || "El número debe ser de 8 carácteres",
      ],
      phoneRules: [
        (v) => !!v || "Ingresa el número de celular",
        (v) => (v && v.length === 9) || "El número debe ser de 9 dígitos",
        (v) => /^\d{0,9}$/.test(v) || "El número debe ser de 9 dígitos",
      ],
      additionalPhoneRules: [
        (v) => !!v || "Ingresa el número de celular adicional",
        (v) => (v && v.length === 9) || "El número debe ser de 9 dígitos",
        (v) => /^\d{0,9}$/.test(v) || "El número debe ser de 9 dígitos",
      ],
      pasaporteRules: [
        (v) => !!v || "El número de documento es requerido",
        (v) => (v && v.length === 11) || "El número debe ser de 11 carácteres",
      ],
      ptpteRules: [
        (v) => !!v || "El número de documento es requerido",
        (v) => (v && v.length === 9) || "El número debe ser de 9 carácteres",
      ],
      DocumentType: ["DNI", "Pasaporte", "Carnet de Extranjeria", "Permiso Temporal de Permanencia"],
      menu: false,
      itemsComoKonecta: [
        "Bumeran",
        "Computrabajo",
        "Columbia",
        "Facebook",
        "Instagram",
        "TikTok",
        "Programa Basta Ya",
        "Programa Inkluye",
        "Programa SUD",
        "Referido/a",
        "Feria Laboral",
        "Bolsa Laboral Instituto",
        "Bolsa Laboral Universidad",
        "Ministerio de Trabajo",
      ],
      lastName1Rules: [
        (v) => (!!v && v.trim().length > 0) || "Apellido paterno es requerido",
        (v) =>
          /^[áéíóúÁÉÍÓÚñÑäöüÄÖÜ a-zA-Z]+$/.test(v) ||
          "El apellido  no es válido , sólo se aceptan letras, tílde y espacio",
      ],
      lastName2Rules: [
        (v) => (!!v && v.trim().length > 0) || "Apellido materno es requerido",
        (v) =>
          /^[áéíóúÁÉÍÓÚñÑäöüÄÖÜ a-zA-Z]+$/.test(v) ||
          "El apellido no es válido, sólo se aceptan letras, tílde y espacio",
      ],
      emailRules: [(v) => !!v || "El correo es requerido", (v) => /.+@.+\..+/.test(v) || "El correo no es válido"],
      emailConfirmationRules: [
        (v) => !!v || "Es requerido la confirmación del correo",
        (v) => v === this.correo || "No se encontraron coincidencias",
      ],
      availableArequipaDistricts: [
        "Arequipa",
        "Alto Selva Alegre",
        "Cayma",
        "Cerro Colorado",
        "Characato",
        "Chiguata",
        "Jacobo Hunter",
        "Jose Luis Bustamante y Rivero",
        "La Joya",
        "Mariano Melgar",
        "Miraflores",
        "Mollebaya",
        "Paucarpata",
        "Pocsi",
        "Polobaya",
        "Quequeña",
        "Sabandia",
        "Sachaca",
        "San Juan de Siguas",
        "San Juan de Tarucani",
        "Santa Isabel de Siguas",
        "Socabaya",
        "Tiabaya",
        "Uchumayo",
        "Vitor",
        "Yanahuara",
        "Yarabamba",
        "Yura",
      ],
      availableTrujilloDistricts: [
        "El Porvenir",
        "Florencia de Mora",
        "Huanchaco",
        "La Esperanza",
        "Laredo",
        "Moche",
        "Poroto",
        "Salaverry",
        "Simbal",
        "Trujillo",
        "Víctor Larco Herrera",
      ],
      availableChiclayoDistricts: [
        "Cayaltí",
        "Chiclayo",
        "Chongoyape",
        "Eten",
        "Puerto Eten",
        "José Leonardo Ortiz",
        "La Victoria",
        "Lagunas",
        "Monsefú",
        "Nueva Arica",
        "Oyotún",
        "Pátapo",
        "Picsi",
        "Pimentel",
        "Pomalca",
        "Pucalá",
        "Reque",
        "Santa Rosa",
        "Tumán",
        "Zaña",
      ],
      availablePiuraDistricts: [
        "Piura",
        "Castilla",
        "Catacaos",
        "La Arena",
        "La Unión",
        "Las Lomas",
        "Tambo Grande",
        "Cura Mori",
        "El Tallán",
        "Veintiséis de Octubre",
      ],
      availableLimaDistricts: [
        "Ancón",
        "Ate",
        "Barranco",
        "Breña",
        "Carabayllo",
        "Chaclacayo",
        "Chorrillos",
        "Cieneguilla",
        "Comas",
        "El agustino",
        "Independencia",
        "Jesús María",
        "La Molina",
        "La Victoria",
        "Lima",
        "Lince",
        "Los Olivos",
        "Lurigancho",
        "Lurín",
        "Magdalena del mar",
        "Miraflores",
        "Pachacámac",
        "Pucusana",
        "Pueblo Libre",
        "Puente Piedra",
        "Punta Hermosa",
        "Punta Negra",
        "Rímac",
        "San Bartolo",
        "San Borja",
        "San Isidro",
        "San Juan de Lurigancho",
        "San Juan de Miraflores",
        "San Luis",
        "San Martin de Porres",
        "San Miguel",
        "Santa Anita",
        "Santa María del Mar",
        "Santa Rosa",
        "Santiago de Surco",
        "Surquillo",
        "Villa El Salvador",
        "Villa María del Triunfo",
      ],
    };
  },
  computed: {
    isEmailValid() {
      if (!this.addPersonalData.correo) return false;
      return this.emailRules.every(rule => rule(this.addPersonalData.correo) === true);
    },
    computedDateFormatted() {
      return this.formatDate(this.addPersonalData.fecha_nac);
    },
    emailConfirmationRules2() {
      return () =>
        this.addPersonalData.correo === this.addPersonalData.correoConfirmacion || "No se encontraron coincidencias";
    },
    countdownDisplay() {
      const m = String(Math.floor(this.countdown / 60)).padStart(2, "0");
      const s = String(this.countdown % 60).padStart(2, "0");
      return `${m}:${s}`;
    },
  },
  watch: {
    menu(val) {
      // eslint-disable-next-line no-unused-expressions
      // eslint-disable-next-line no-return-assign
      return val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    'addPersonalData.telefono'(newValue) {
      this.addPersonalData.telefonoReferencial = newValue;
    },
  },
  methods: {
    isAdult() {
      const date1 = new Date();
      date1.setMonth(date1.getMonth() - 216);
      const finalDate = `${date1.getFullYear()}-${date1.getMonth() + 1}-${date1.getDate()}`;
      return finalDate;
    },
    changeDistrict(district) {
  let districtSelected;
  this.addPersonalData.distrito = "";

  switch (district) {
      case "A":
        districtSelected = "Lima";
        this.availableDistricts = this.availableLimaDistricts;
        break;
      case "Q":
      case "AREQUIPA":
        districtSelected = "Arequipa";
        this.availableDistricts = this.availableArequipaDistricts;
        break;
      case "E":
        districtSelected = "Chiclayo";
        this.availableDistricts = this.availableChiclayoDistricts;
        break;
      case "P":
        districtSelected = "Piura";
        this.availableDistricts = this.availablePiuraDistricts;
        break;
      case "T":
        districtSelected = "Trujillo";
        this.availableDistricts = this.availableTrujilloDistricts;
        break;
      case "OTHER":
        break;
    }

    this.$gtag?.event(`LP_Residencia${districtSelected}`, {
      event_category: `LP_Residencia${districtSelected}`,
      event_label: `LP_Residencia${districtSelected}`,
      value: 1,
    });
  },

    isNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    saveBirthDay(fechaNac) {
      this.$refs.menu.save(fechaNac);
    },
    changeGender(gender) {
      this.$gtag?.event(`LP_Sexo_${gender}`, {
        event_category: `LP_Sexo_${gender}`,
        event_label: `LP_Sexo_${gender}`,
        value: 1,
      });
    },
    changeDiscapacidad() {
      this.addPersonalData.tipoDiscapacidad = "";
      this.addPersonalData.tieneCarnetConadis = null;      
    },
    changeReference(reference) {
      this.$gtag?.event(`LP_select_${reference}`, {
        event_category: `LP_select_${reference}`,
        event_label: `LP_select_${reference}`,
        value: 1,
      });
    },
    startCountdown() {
      // Limpia si hubiera uno corriendo
      if (this.timerId) clearInterval(this.timerId);

      this.timerId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timerId);
          this.timerId = null;
          this.otpSent = false; // re-habilita campos y botón
        }
      }, 1000);
    },
    async validateEmail() {
      const email = this.addPersonalData.correo;

      if (!this.isEmailValid) {
        return;
      }

      this.isLoading = true;

      try {
        await this.$recaptchaLoaded();
        const gcaptcha = await this.$recaptcha("send_token");
        await sendToken(email, gcaptcha);
        this.otpSent = true;
        this.countdown = 120;
        this.startCountdown();
      } catch (error) {
        console.error("Error al enviar token:", error);
      } finally {
        this.isLoading = false;
      }
    },
    onOtpInput(valor) {
      if (valor.length === 6) {
        this.validateOtp(valor);
      }
    },

    async validateOtp(valor) {
      this.isLoading = true;
      try {
        await this.$recaptchaLoaded();
        const gcaptcha = await this.$recaptcha("validate_otp");
        const response = await validToken({ email: this.addPersonalData.correo, token: valor, gcaptcha });
        if (response.success) {
          this.otpSuccess = true;
          this.otpSent = true;
        } else {
          this.otpSuccess = false;
          this.addPersonalData.otp = "";
          this.showModalValidate = true;
          this.modalType = "tokenNotFound";
        }
      } catch (error) {
        console.error("Error al validar token:", error);
      } finally {
        this.isLoading = false;
      }
    },

    isSixteenYearsOld() {
      const today = new Date();
      const sixteenYearsAgo = new Date(today.getFullYear() - 16, today.getMonth(), today.getDate());
      const formattedDate = sixteenYearsAgo.toISOString().split("T")[0];
      return formattedDate;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-application .title {
  line-height: 23px !important;
}

.input-google-container {
  width: 100%;
  margin-top: 0.5em;
}

.input-autocomplete {
  margin-bottom: 2em;
  border-bottom: 2px solid #bdbdbd;
  transition: border-bottom 0.5s ease, width 0.5s ease;
  width: 100%;
}

.input-autocomplete:focus {
  width: 100%;
  border-bottom: 2px solid #168d86;
  outline: none;
}

.text-marker-content {
  display: flex;
  margin-bottom: 1em;
}

.marker-image {
  width: 20px;
  height: 30px;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
</style>
